import Article from '../src/Article/index';
export default Article;
